import React from 'react';
import Icon from '../../../components/AppIcon';

const WeatherOverlay = ({ weatherData, isVisible }) => {
  if (!isVisible || !weatherData) return null;

  return (
    <div className="absolute top-20 right-4 bg-card/95 backdrop-blur-sm rounded-lg shadow-conservation-lg p-4 w-64 z-[400] animation-organic">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-foreground flex items-center gap-2">
          <Icon name="CloudRain" size={20} color="var(--color-primary)" />
          Weather Conditions
        </h3>
      </div>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Temperature</span>
          <span className="font-medium text-foreground">{weatherData?.temperature}°C</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Humidity</span>
          <span className="font-medium text-foreground">{weatherData?.humidity}%</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Wind Speed</span>
          <span className="font-medium text-foreground">{weatherData?.windSpeed} km/h</span>
        </div>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Precipitation</span>
          <span className="font-medium text-foreground">{weatherData?.precipitation}mm</span>
        </div>
        
        <div className="pt-3 border-t border-border">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Clock" size={12} />
            <span>Last updated: {weatherData?.lastUpdated}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherOverlay;